import React, { useEffect } from "react";
import DetailedPost from "../components/SinglePost/DetailedPost";
import RelatedPostsSidebar from "../components/RelatedPosts/RelatedPostsSidebar";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchPost } from "../features/post/postSlice";
import Loading from "../components/Others/Loading";

const BlogPost = () => {
  const { post, isLoading, isError, error } = useSelector(
    (state) => state.post
  );

  const {likes} = post
  const dispatch = useDispatch();

  const { postID } = useParams();

  useEffect(() => {
    dispatch(fetchPost(postID));
  }, [dispatch, postID, likes ]);

  const { id, tags } = post || {};

  // decide what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError && !post?.id) {
    content = <div className="col-span-12">No post found!</div>;
  }

  if (!isLoading && !isError && post?.id) {
    content = (
      <>
        <DetailedPost post={post} />
        <RelatedPostsSidebar currentPostId={id} tags={tags} />
      </>
    );
  }

  return <section className="post-page-container">{content}</section>;
};

export default BlogPost;
